import { call, put, takeLatest } from 'redux-saga/effects';

import { default as SyncService } from './sync.service';
import {
  CREATE_SYNC_REQUEST,
  createSyncFailure,
  createSyncSuccess,
  FETCH_SYNC_REQUEST,
  fetchSyncFailure,
  fetchSyncSuccess,
} from './sync.action';

import { FetchSyncPayload, SyncAction, SyncActionPayload, SyncResponse } from './sync.state';

import { showSnackbar } from 'helpers/common.helper';
import { FormattedTranslation } from 'translations/helper';

function* createSync(action: SyncAction): Generator<any> {
  try {
    const response = (yield call(
      SyncService.createSync,
      action.payload as SyncActionPayload,
    )) as SyncResponse;
    yield put(createSyncSuccess(response));
    showSnackbar({
      message: FormattedTranslation({
        i18nKey: 'DASHBOARD_BUSINESS_MANAGE_SERVICES_SYNC_SUCCESS',
      }),
      type: 'success',
    });
  } catch (error) {
    yield put(createSyncFailure(error));
    showSnackbar({
      message: FormattedTranslation({
        i18nKey: 'DASHBOARD_BUSINESS_MANAGE_SERVICES_SYNC_ERROR',
      }),
      type: 'error',
    });
  }
}

function* fetchSyncStatuses(action: SyncAction): Generator<any> {
  try {
    const response = (yield call(
      SyncService.fetchSyncStatuses,
      action.payload as FetchSyncPayload,
    )) as { status: string; value: SyncResponse }[];

    yield put(fetchSyncSuccess(response));
  } catch (error) {
    yield put(fetchSyncFailure(error));
  }
}

function* createSyncSaga(): Generator<any> {
  yield takeLatest(CREATE_SYNC_REQUEST, createSync);
}

function* fetchSyncSaga(): Generator<any> {
  yield takeLatest(FETCH_SYNC_REQUEST, fetchSyncStatuses);
}

export { createSync, fetchSyncStatuses };
export const syncSaga = [createSyncSaga(), fetchSyncSaga()];
